












































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"

export interface BaseSheet{
  nendo: string
  times: string
  grades: number[]
  curriculum_ids: number[]
  room_codes: number[]
  levels: string[]
  event_code: string
}

export interface Data {
  base_sheet_id: string
  baseSheet: BaseSheet | null
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const state = reactive<Data>({
      base_sheet_id: null,
      baseSheet: null,
      errors: []
    });

    const create = async () => {

      if(!window.confirm("ダミー試験情報を作成します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/qr_base_sheet_upload/create_dummy_data`, {base_sheet: state.baseSheet}).then(response => {
        alert("処理が完了しました。");
        // window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.baseSheet = {nendo: "", grades: [], times: "", curriculum_ids: [], room_codes: [], levels: [], event_code: ""};
    });

    return {
      ...toRefs(state),
      create,
    }
  },
})
